import React from 'react';
import { FONTS } from 'styles/theme';
import { SwitchProfileButton } from 'components/auth/AuthActions';
import PageHero from 'components/shared/PageHero';
import { LANDING_ASSETS } from 'constants/storefrontAssets';

const MealPlanHeader = ({ customer }) => (
    <PageHero
        subtitle="Personalized Subscription Meal Plan"
        backgroundImage={LANDING_ASSETS.mealPlanBanner}
        backgroundPosition="center 45%"
        marginBottom="28px"
    >
        <p style={{
            margin: 0,
            color: '#ffffff',
            fontFamily: FONTS.sans,
            fontWeight: 700,
            fontSize: 'clamp(12px, 2vw, 18px)',
            wordBreak: 'break-word'
        }}>
            {customer.name} • {customer.email}
        </p>
        <SwitchProfileButton style={{ color: '#ffffff', fontFamily: FONTS.sans, fontSize: 'clamp(12px, 1.6vw, 15px)', marginTop: '8px' }} />
    </PageHero>
);

export default MealPlanHeader;
